import {memo, useEffect, useRef, useState} from 'react';
import {Id, ToastContainer, cssTransition, toast} from 'react-toastify';
import {errorLayerStyles as styles} from './ErrorLayer. styles';
import {Box} from '@mui/material';
import {MODAL_LAYER_Z_INDEX} from '../modal-layers';

type ErrorToastData = {
  withoutBackdrop?: boolean;
};

export const ErrorToastLayer = () => {
  const [hasErrorToast, setHasErrorToast] = useState(false);
  const trackedToastsRef = useRef<Set<Id>>(new Set());

  useEffect(() => {
    const tracked = trackedToastsRef.current;

    const unsubscribe = toast.onChange((payload) => {
      // Некоторые ошибки отображаются в дефолтных тостерах
      const isErrorOrDefault = payload.type === 'error' || payload.type === 'default';

      if (payload.containerId !== 'error' || !isErrorOrDefault) return;

      const toastData = (payload.data as ErrorToastData | undefined) ?? {};
      const requiresBackdrop = !toastData.withoutBackdrop;

      if (payload.status === 'removed' || !requiresBackdrop) {
        tracked.delete(payload.id);
      } else {
        tracked.add(payload.id);
      }

      setHasErrorToast(tracked.size > 0);
    });

    return () => {
      unsubscribe();
      tracked.clear();
      setHasErrorToast(false);
    };
  }, []);

  return (
    <>
      <ToastContainer
        containerId="error"
        style={{top: '16%', zIndex: MODAL_LAYER_Z_INDEX.feedbackContent}}
        position="top-center"
        transition={InstantZoom}
        toastClassName="toast-body"
        className="toast-container"
      />
      {hasErrorToast && <Backdrop />}
    </>
  );
};

type BackdropProps = {
  onClick?: () => void;
};

const InstantZoom = cssTransition({
  enter: 'Toastify__zoom-enter',
  exit: 'Toastify__zoom-exit',
  collapse: false,
});

const Backdrop = memo(({onClick}: BackdropProps) => <Box onClick={onClick} sx={styles.backdrop} />);
